module.exports = __webpack_public_path__ + "static/media/iDocBrowser.73829b5d.jpg";